<dx-select-box
  [name]="name"
  [width]="300"
  [dataSource]="dataSource$ | async"
  [value]="value"
  (valueChange)="valueChange.emit($event)"
  (selectedItemChange)="selectedItemChange.emit($event)"
  [readOnly]="readOnlySig()"
  [disabled]="disabledSig()"
  [label]="label"
  [labelMode]="labelMode"
  [placeholder]="placeholder"
  [displayExpr]="LookupKeys.description"
  [valueExpr]="LookupKeys.value"
  [searchEnabled]="true"
  [showClearButton]="true"
>
  <dx-validator *ngIf="isRequiredSig()" [validationGroup]="validationGroup">
    <dxi-validation-rule
      type="required"
      [message]="requiredText"
    ></dxi-validation-rule>
  </dx-validator>
</dx-select-box>
